export type UsageKey = 'notes' | 'storage' | 'members' | 'departments' | 'actions' | 'proposals' | 'connections';
export type UsageItem = { key: UsageKey; used: number; limit: number | null };
export type PlanUsage = {
  hosted: boolean; planId: string | null; unlimited: boolean; billingAvailable: boolean;
  canManageBilling: boolean; accountUrl: string | null; resetsAt: string; pendingInvitations: number;
  historyDays: number | null; contentSyncAvailable: boolean; inactivityPauseAvailable: boolean; usage: UsageItem[];
};
export const PLAN_LIMIT_CODES = new Set(['seat_limit', 'department_limit', 'storage_limit', 'note_limit', 'actions_limit', 'proposals_limit', 'connection_limit', 'automation_limit', 'history_limit']);
export const isStructural = (key: UsageKey) => ['members', 'departments', 'connections'].includes(key);
export function usageLevel(item: UsageItem): 'normal' | 'near' | 'full' {
  if (item.limit === null) return 'normal';
  if (item.used >= item.limit) return 'full';
  return item.limit > 0 && item.used / item.limit >= .8 ? 'near' : 'normal';
}
export function formatBytes(bytes: number) {
  if (bytes === 0) return '0 B';
  const units = ['B', 'KB', 'MB', 'GB', 'TB'];
  const power = Math.min(Math.floor(Math.log10(Math.max(1, bytes)) / 3), units.length - 1);
  return `${new Intl.NumberFormat(undefined, { maximumFractionDigits: power ? 1 : 0 }).format(bytes / 1000 ** power)} ${units[power]}`;
}
export function usageValue(item: UsageItem) {
  const format = item.key === 'storage' ? formatBytes : (n: number) => new Intl.NumberFormat().format(n);
  return item.limit === null ? format(item.used) : `${format(item.used)} of ${format(item.limit)}`;
}
export function resetLabel(iso: string) { return new Date(iso).toLocaleDateString(undefined, { month: 'short', day: 'numeric', timeZone: 'UTC' }); }
